// Roster Spares CONFIRM: a team official confirms a roster spare (affiliate)
// for one game (SN-8476). Shared by web + mobile.
//
// The flag is `is_promoted` on the roster player, stored per game; the write
// lives in common/services/game/rosterSpareConfirmService.ts.
export const ROSTER_SPARE_CONFIRM_FIELD = 'is_promoted' as const

export type RosterSpareConfirmPlayer = {
  id: string
  is_affiliate?: boolean | null
  is_spare?: boolean | null
} & Partial<Record<typeof ROSTER_SPARE_CONFIRM_FIELD, boolean | null>>

export const isRosterSpareConfirmed = (
  player: Partial<RosterSpareConfirmPlayer> | null | undefined
): boolean => Boolean(player?.[ROSTER_SPARE_CONFIRM_FIELD])

/** A Roster Spares player: affiliate or spare (same split as getPlayersAndAffiliates). */
export const isRosterSpare = (
  player: Partial<RosterSpareConfirmPlayer> | null | undefined
): boolean => !!(player?.is_affiliate || player?.is_spare)

/**
 * A Roster Spares player not yet confirmed for the game. A promoted spare
 * candidate (id in `promotedRequestById`) is already confirmed.
 */
export const isUnconfirmedRosterSpare = (
  player: RosterSpareConfirmPlayer | null | undefined,
  promotedRequestById?: Readonly<Record<string, string>>
): boolean =>
  !!player &&
  isRosterSpare(player) &&
  !promotedRequestById?.[player.id] &&
  !isRosterSpareConfirmed(player)
